import React, { Component } from "react";
import PersonalInformation from "./PersonalInformation";
import locales from "../../../_constants/locales";
import "../styles/PersonalInformationSection.css";

class PersonalInformationSection extends Component {
    render() {
        return (
            <div className="section personal-information-section">
                <div className="section-header">
                    <div className="layout horizontal center title-row">
                        <h2 className="title"> {locales[this.props.language.code].TICKET_CONFIRMATION.PERSONAL_INFORMATION.TITLE}</h2>
                    </div>
                </div>
                <div className="section-body">
                    <div className="flex layout vertical">
                        <div className="personal-information-section-box">
                            <PersonalInformation language={this.props.language} personalInformation={this.props.personalInformation} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PersonalInformationSection;
